<template>
  <div class="position-relative">
    <InputView type="text" :size="size" :value="filter" @update:value="filter = $event" :max="50" @focus="focused = true" @blur="focused = false"/>
    <div v-if="!focused && filter.length === 0" class="position-absolute d-flex align-items-center ms-3" style="top: 0; left: 0; bottom: 0">
      <i class="fas fa-magnifying-glass text-muted"></i>
    </div>
  </div>
</template>

<script>
import InputView from "../forms/inputs/InputView.vue";

export default {
  name: "CollectionSearchView",
  emits: ["update:value"],
  components: {InputView},
  props: {
    value: String,
    size: String
  },
  data() {
    return {
      filter: "",
      timeout: undefined,
      focused: false
    }
  },
  mounted() {
    this.filter = this.value;
  },
  watch: {
    value() {
      if (this.value !== this.filter) this.filter = this.value;
    },
    filter: function() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("update:value", this.filter);
      }, 300);
    },
  }
}
</script>